import { Paper, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

interface CommunicationOptionProps {
  selected: boolean;
  disabled?: boolean;
}

export const CommunicationOption = styled(Paper)(
  ({ selected, disabled }: CommunicationOptionProps) => {
    const color = disabled ? colors.gray400 : colors.gray700;

    return {
      borderColor: selected ? colors.brandBlue500 : colors.gray200,
      borderRadius: "8px",
      color: selected ? colors.brandBlue500 : color,
      padding: "12px",
      paddingInline: "16px",
      "&:hover": {
        cursor: disabled ? "not-allowed" : "pointer",
      },
      "& .MuiTypography-root": {
        color: selected ? colors.brandBlue500 : color,
        fontFamily: "Manrope",
        fontSize: 14,
        lineHeight: "150%",
      },
      "& .MuiTypography-root.mainText": {
        fontWeight: 700,
      },
      "& .MuiTypography-root.subText": {
        fontWeight: 400,
      },
    };
  }
);

const styles = makeStyles(() => ({
  modal: {
    width: "676px !important",
    "& [class*='makeStyles-header-']": {
      padding: "24px 32px 0 32px !important",
      "& MuiIconButton-root": {
        right: "-12px",
      },
    },
    "& [class*='makeStyles-body-']": {
      margin: "unset",
      padding: "32px",
    },
  },
  stack: {
    width: "100%",
  },
}));

export default styles;
